/** Mesmo intervalo padrão da tela Entregas (ontem → amanhã), alinhado ao resumo e ao badge do menu. */
export function defaultEntregasDateRange(){
	const pad = (n) => String(n).padStart(2, '0');
	const toYMD = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
	const today = new Date();
	const prev = new Date(today);
	prev.setDate(prev.getDate() - 1);
	const next = new Date(today);
	next.setDate(next.getDate() + 1);
	return { dataInicio: toYMD(prev), dataFim: toYMD(next) };
}
